/* eslint-disable no-param-reassign */
import { call, put, select } from 'redux-saga/effects';
import { extendCQAfterSale as extendCQAfterSaleAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';
const contextStore = state => state.context.data;

export function* extendCQAfterSale(params) {
  const {
    customerInquirySpecId,
    productId,
    cqId,
    reduxUpdate,
    normalizeHttpErrors,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const args = {
      customerInquirySpecId,
      productId,
      cqId,
    };
    const context = yield select(contextStore);
    const response = yield call(extendCQAfterSaleAda, args, context);

    if (response.customerQuoteId) {
      if (successUpdate) {
        yield put(successUpdate(response.customerQuoteId));
      }
      return response;
    }

    throw error; // TODO Revisar con Hector -> Es a propósito para que salte al catch?
  } catch (error) {
    console.log(error);
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(
      normalizeHttpErrors,
      WEB_SERVICES.EXTEND_CQ_AFTER_SALE,
      error,
    );
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }
    throw error;
  }
}